<template>
  <div class="log-in-to-access">
    <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
      :fullscreen="breakpoint.xsOnly"
      :hide-overlay="breakpoint.xsOnly"
    >
      <v-card rounded center>
        <v-toolbar dense flat color="grey darken-3" dark>
          <v-toolbar-title>Log in to continue</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p>Please log in or create an account to use this feature.</p>
          <v-btn
              class="mt-2 mb-2"
              block
              color="teal"
              dark
              @click="navigateTo('login')"
              >Log in</v-btn
            >
            <v-btn
              class="mt-3 mb-1"
              block
              color="teal"
              dark
              @click="navigateTo('signup')"
              >Sign up</v-btn
            >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "loginToAccessDialog",
  data() {
    return {

    }
  },
  methods: {
    navigateTo(target) {
      this.showDialog = false;
      if (target === "login") {
        this.$store.dispatch("setShowLogInDialog", true);
      } 
      if (target === "signup") {
        this.$store.dispatch("setShowSignUpDialog", true);
      } 
    }
    
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showDialog: {
      get() {
        return this.$store.getters.getShowLoginToAccessDialog;
      },
      set(value) {
        this.$store.dispatch("setShowLoginToAccessDialog", value);
      }
    }
  }
}
</script>

<style>

</style>